import { useState } from 'react';

interface TooltipProps {
  content: string;
  children?: React.ReactNode;
}

/** Hover tooltip for form field explanations. */
export default function Tooltip({ content, children }: TooltipProps) {
  const [show, setShow] = useState(false);

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children ?? (
        <span className="ml-1 w-4 h-4 rounded-full bg-gray-600 text-gray-300 text-xs flex items-center justify-center cursor-help">
          ?
        </span>
      )}
      {show && (
        <span className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 text-xs text-gray-300 bg-[#1e1e30] border border-[#2a2a3e] rounded-lg p-2 shadow-xl pointer-events-none whitespace-normal">
          {content}
        </span>
      )}
    </span>
  );
}
